const baseurl = "https://devapi.verifymate.app";
const profilePlatform = "";
const dev_env = "";
const prod_env = "/prod";
const release_env = "/release";

const dev = {
  graphqlendpoint: {
    URL: baseurl + dev_env + "/unverifiedEmployer/graphql"
  },
  siteKey: "6LeCepsUAAAAAPJoAWAG97Nwosc_KukG-8syoZoj",
  profileImage: {
    ProfileRetrieve: baseurl + dev_env + profilePlatform + "/retrieve"
  }
};

const prod = {
  graphqlendpoint: {
    URL: baseurl + prod_env + "/unauthorizedGraphql"
  },
  profileImage: {
    ProfileRetrieve: baseurl + prod_env + profilePlatform + "/retrieve"
  }
};

const release = {
  graphqlendpoint: {
    URL: baseurl + release_env + "/unauthorizedGraphql"
  },
  profileImage: {
    ProfileRetrieve: baseurl + release_env + profilePlatform + "/retrieve"
  }
};

const configuration =
  process.env.REACT_APP_HOST_ENV === "prod"
    ? prod
    : process.env.REACT_APP_HOST_ENV === "release"
    ? release
    : dev;
export default {
  // Add common config values here
  MAX_ATTACHMENT_SIZE: 5000000,
  ...configuration
};



// WEBPACK FOOTER //
// ./src/config.js